const StorageKey = 'device';
export type SupportEvent = 'SharedWorker' | 'indexedDB';

function getReportedEvents(): Record<SupportEvent, boolean> {
  return JSON.parse(localStorage.getItem(StorageKey)) || {};
}

export function getReportedEvent(key: SupportEvent) {
  return getReportedEvents()[key];
}

export function saveReportedEvent(key: SupportEvent, val: boolean) {
  localStorage.setItem(
    StorageKey,
    JSON.stringify({
      ...getReportedEvents(),
      [key]: val,
    })
  );
}
